export function showCheckIcon (item) {
  return item.category === '商品券' ||
    item.category === 'クレジットカード'
}
